module.exports = __webpack_public_path__ + "site/img/16.0528ee09.jpg";